import { ResourceCategoriesServant } from './../servants/resource_categories_servant';
import * as _4 from 'lodash4';
import { ResourceCategory } from './../builders/resource_category_builder';
import { Resource } from './../builders/resource_builder';
import { IResourcesDatasource } from './../datasources/resources_datasource';
import { IResourceCategoriesDatasource } from './../datasources/resource_categories_datasource';
import { IQuery, IQueryMediator, key } from 'core-ts-types';

export interface IResourceCategoriesQueryResult {
  id: key;
  name: string;
  resources: Resource[];
}

export class ResourceCategoriesQuery implements IQuery {
  private _result: {
    categories: IResourceCategoriesQueryResult[];
    nonEmptyCategories: IResourceCategoriesQueryResult[];
    selectedCategory: IResourceCategoriesQueryResult;
    selectedIndex: number;
  };

  constructor(
    QueryMediator: IQueryMediator,
    private ngResourcesDatasource: IResourcesDatasource,
    private ngResourceCategoriesDatasource: IResourceCategoriesDatasource
  ) {
    QueryMediator.registerQuery(this, ngResourcesDatasource, ngResourceCategoriesDatasource);
  }

  run() {
    const resources = this.ngResourcesDatasource.values();
    const resourceCategories = this.ngResourceCategoriesDatasource.values();
    const categories = ResourceCategoriesServant.getCategories(resourceCategories, resources);

    const selectedCategory: IResourceCategoriesQueryResult =
      (this.ngResourceCategoriesDatasource.model.selected
        ? _(categories).find(
            (category: IResourceCategoriesQueryResult) =>
              category.id === this.ngResourceCategoriesDatasource.model.selected
          )
        : undefined) || _.first(categories);

    const prevSelectedCategoryId = _4.get(this._result, 'selectedCategory.id');
    const selectedCategoryId = _4.get(selectedCategory, 'id');

    const validMinSelectedIndex = 0;
    const validMaxSelectedIndex = _4.max([validMinSelectedIndex, selectedCategory.resources.length - 1]);
    let selectedIndex = validMinSelectedIndex;

    const updatingSameCategory = _4.isNumber(selectedCategoryId) && _4.eq(prevSelectedCategoryId, selectedCategoryId);
    if (updatingSameCategory) {
      selectedIndex = _4.get(this._result, 'selectedIndex');
    }

    if (selectedIndex > validMaxSelectedIndex) {
      selectedIndex = validMaxSelectedIndex;
    }

    this._result = {
      categories: categories,
      nonEmptyCategories: categories.filter((category) => !_4.isEmpty(category.resources)),
      selectedCategory: selectedCategory,
      selectedIndex
    };

    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-resources').service('ngResourceCategoriesQuery', ResourceCategoriesQuery);



// WEBPACK FOOTER //
// ./app/lib/resources/queries/resource_categories_query.ts